// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"58b4158462da0417","src_app_bulk-user-update_bulk-user-update_module_ts":"833bb385d8229148"}[chunkId] + ".js";
};